import { queryOptions } from '@tanstack/react-query';
import { configurationsApi } from './configurations.api';

export const configurationKeys = {
  all: ['app-settings'] as const,
  // Nested under `all` so a settings save (which invalidates `all`) also
  // refreshes the live quota denominator.
  scanPageQuota: ['app-settings', 'scan-page-quota'] as const
};

export const configurationQueries = {
  all: () =>
    queryOptions({
      queryKey: configurationKeys.all,
      queryFn: () => configurationsApi.getAll(),
      staleTime: 5 * 60 * 1000 // 5 minutes — settings rarely change
    }),
  scanPageQuota: () =>
    queryOptions({
      queryKey: configurationKeys.scanPageQuota,
      queryFn: () => configurationsApi.getScanPageQuota(),
      staleTime: 30 * 1000 // usage changes as pages are scanned/deleted
    })
};
